// src/pages/Users/Produits/components/FloatingDonationButton.jsx

import React from "react";
import { FaHeart } from "react-icons/fa";

export default function FloatingDonationButton({ donationUrl }) {
  return (
    <div className="fixed inset-x-0 bottom-3 z-40 px-3 sm:hidden">
      <a
        href={donationUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="mx-auto flex min-h-14 max-w-md items-center justify-center gap-3 rounded-2xl bg-gradient-to-r from-pink-500 to-violet-500 px-5 text-sm font-bold text-white shadow-2xl shadow-pink-500/30 ring-1 ring-white/20 active:scale-[0.98]"
      >
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/20">
          <FaHeart className="animate-pulse" />
        </span>
        Soutenir le développement · 5 €
      </a>
    </div>
  );
}